import React from 'react';

import { ImgLazyLoader, TextButton } from '../../index';
import { PanelsPanelContainer, PanelsPanelTitle, PanelsPanelContent, PanelsPanelType, PanelsPanelContainerImg } from './Panel.style';

type PanelProps = React.PropsWithChildren<{
  title: string,
  type: string,
  to?: string,
  button?: JSX.Element,
  content: string,
  image: string,
  posts: any,
}>;

export const Panel = ({ title, type, to, button, content, image, posts } : PanelProps) => {
  return (
    <PanelsPanelContainer posts={posts}>
      <ImgLazyLoader>
        <PanelsPanelContainerImg src={image} alt={title} />
      </ImgLazyLoader>
      {posts && type && <PanelsPanelType>{type}</PanelsPanelType>}
      <PanelsPanelTitle posts={posts}>
        {to && <TextButton to={to}>{title}</TextButton>}
      </PanelsPanelTitle>
      <PanelsPanelContent posts={posts} dangerouslySetInnerHTML={{ __html: content }} />
      {button}
    </PanelsPanelContainer>
  );
};

